import { memberPlans } from "@/mocks/members";

export default function Pricing() {
  return (
    <section id="pricing" className="relative py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 text-center md:mb-14">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-400">
            <i className="ri-vip-diamond-line"></i>
            会员套餐
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
            选择你的<span className="text-gradient-gold">尊享方案</span>
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-400">
            透明定价、明码标价，按需升级你的阅读体验。黄金·土豪专属会员，解锁全部 VIP 章节与抢先看权益。
          </p>
        </div>

        <div className="grid gap-5 lg:grid-cols-3">
          {memberPlans.map((plan) => (
            <article
              key={plan.id}
              className={`relative flex flex-col rounded-lg border p-6 transition-colors md:p-7 ${
                plan.highlight
                  ? "border-primary-500/70 bg-primary-500/5"
                  : "border-background-600/60 bg-background-900/50"
              }`}
            >
              {plan.highlight && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-1 text-xs font-bold text-background-950">
                  {plan.tag}
                </span>
              )}
              {plan.badge && (
                <span className="absolute -top-3 right-4 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
                  {plan.badge}
                </span>
              )}

              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-foreground-50">{plan.name}</h3>
                <span className="text-xs text-foreground-400">{plan.period}</span>
              </div>

              <div className="mt-4 flex items-baseline gap-2">
                <span className="font-heading text-4xl font-black text-primary-400">{plan.price}</span>
                <span className="text-sm text-foreground-500 line-through">{plan.originalPrice}</span>
              </div>

              <ul className="mt-5 flex flex-1 flex-col gap-2.5">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-foreground-300">
                    <i
                      className={`mt-0.5 ${plan.highlight ? "text-primary-400" : "text-secondary-300"} ri-check-line`}
                    ></i>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#subscribe"
                className={`mt-6 whitespace-nowrap rounded-md px-5 py-3 text-center text-sm font-bold transition-colors ${
                  plan.highlight
                    ? "bg-primary-500 text-background-950 hover:bg-primary-400"
                    : "border border-primary-500/50 text-primary-300 hover:bg-primary-500/10"
                }`}
              >
                立即开通
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}